.root {
  stroke: var(--matterColor);
}
